import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface MarketingScrollRedirectProps {
  scrollTo: string;
}

/** Sends legacy marketing URLs to the single landing page and scrolls to a section. */
const MarketingScrollRedirect: React.FC<MarketingScrollRedirectProps> = ({ scrollTo }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true, state: { scrollTo } });
  }, [navigate, scrollTo]);

  return null;
};

export default MarketingScrollRedirect;
